import { render, staticRenderFns } from "./SwitchPopModal.vue?vue&type=template&id=63ef0d92"
import script from "./SwitchPopModal.vue?vue&type=script&lang=js"
export * from "./SwitchPopModal.vue?vue&type=script&lang=js"
import style0 from "./SwitchPopModal.vue?vue&type=style&index=0&id=63ef0d92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports